/*
 * Deliberately not `readonly ModificationMode[]`: every consumer tests membership of a `BasketMode`
 * against this list, and a narrower element type would reject `creation` at the `includes` call.
 */
// TODO: This variable will be deleted as soon as the old edit modes are removed
export const MODIFICATION_MODES: readonly string[] = ['modifyPrestations', 'modifyAppointment', 'modification'];
